import React, { useState, useEffect } from 'react';
import {
  Label,
  Button,
} from 'reactstrap';
import { DatetimePicker } from '../../../commons/controls';
import Services from '../services';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import _ from 'lodash';
import FileSaver from 'file-saver';
import ListaSelector from './ListaSelector';
import moment from 'moment';
import RFForm from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';

const ListaContent = (props) => {

  let selected = false; 

  const {
    globals,
    active
  } = props;

  const [selectedLista, setSelectedLista] = useState(null); // listaTipus.name
  const [tableStatus, setTableStatus] = useState(null); // ['LOAD', 'TABL', 'DATA', 'NETW']
  const [tableData, setTableData] = useState([]);
  const [loadingButton, toggleLoadingButton] = useState(false);
  const [type, setType] = useState(null);
  const [owner, setOwner] = useState(null);
  const [code, setCode] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [basis, setBasis] = useState(null);
  const [location, setLocation] = useState(null);
  const [status, setStatus] = useState(null);

  const cols = 2;
  const lists = [
    {
      name: "FORGALOM",
      role: "KEDVEZMENY_LISTA_FORGALOM",
      label: "Vásárlói kártyák forgalma",
      listTitle: "vasarloi_kartya_forgalom.xlsx",
      filters: ["startDate", "endDate", "location", "type", "basis"],
      table: [
        { name: "helyszin.nev", label: "Helyszín" },
        { name: "tipus.nev", label: "Vásárlói kártyatípus" },
        { name: "bontas", label: basis && basis.caption + " bontás", dep: [basis], formatter: cell => (cell || "") + basis.label },
        { name: "mennyiseg", label: "Eladott darabszám", style: { textAlign: 'center' } },
        { name: "osszeg", label: "Eladott kártyák értéke", formatter: cell => cell ? cell + " HUF" : "", style: { textAlign: 'center' } }
      ],
      submit: (filters, callback) => Services.listForgalom(filters, callback),
      submitXlsx: (filters, callback) => Services.listForgalomXlsx(filters, callback),
    },
    {
      name: "FELHASZNALAS",
      role: "KEDVEZMENY_LISTA_FELHASZNALAS",
      label: "Vásárlói kártyák felhasználása",
      listTitle: "vasarloi_kartya_felhasznalas.xlsx",
      filters: ["location", "code", "owner", "type", "status"],
      table: [
        { name: "helyszin.nev", label: "Helyszín" },
        { name: "tipus.nev", label: "Kártyatípus" },
        { name: "azonosito", label: "Azonosító" },
        { name: "tulajdonos.nev", label: "Tulajdonos" },
        { name: "kedvezmeny.nev", label: "Kedvezmény típus" },
        { name: "mennyiseg", label: "Felhasználva (db)", style: { textAlign: 'center' } },
        { name: "osszeg", label: "Érvényesített kedvezmény", formatter: cell => cell ? cell + " HUF" : "", style: { textAlign: 'center' } },
      ],
      submit: (filters, callback) => Services.listFelhasznalas(filters, callback),
      submitXlsx: (filters, callback) => Services.listFelhasznalasXlsx(filters, callback),
    },
  ];

  useEffect(() => {
    //setSelectedLista(!active);
  }, [active]);

  useEffect(() => {
    if (tableStatus === 'LOAD') {
      loadList();
    }
  }, [tableStatus]);

  useEffect(() => {
    if (tableData) {
      if (tableData.length > 0) {
        setTableStatus('TABL');
      } else {
        setTableStatus('DATA');
      }
    }
  }, [tableData]);

  useEffect(() => {
    clear(selectedLista);
  }, [selectedLista]);

  useEffect(() => {
    if (loadingButton) {
      loadXlsxList();
    }
  }, [loadingButton]);

  const clear = (selectedLista) => {
    const listElement = lists.find(item => selectedLista == item.name) || {};
    setTableData([]);
    setType(null);
    setOwner(null);
    setCode(null);
    setStartDate(listElement.filters && listElement.filters.includes("startDate") ? startOfDay(new Date()) : null);
    setEndDate(listElement.filters && listElement.filters.includes("endDate") ? endOfDay(new Date()) : null);
    setBasis(null);
    setLocation(null);
    setStatus(null);
  }

  const startOfDay = date => {
    //date.setMonth(date.getMonth() - 2);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  const endOfDay = date => {
    date.setHours(23, 59, 59, 999);
    return date;
  }

  const handleStartDateChange = (date) => {
    const start = moment(date);
    const end = moment(endDate);
    checkDiff(date, start, end, setStartDate);
  }

  const handleEndDateChange = (date) => {
    const start = moment(startDate);
    const end = moment(date);
    checkDiff(date, start, end, setEndDate);
  }

  const handleDateChange = (e,v,type) => {
    if(selected) {
      selected = false;
      let start = null;
      let end = null;
      switch (type) {
        case 'FORMKEZDETE':
          start = moment(e).startOf('day');
          end = moment(endDate);
          checkDiff(start, start, end, setStartDate);
          break;
        case 'FORMVEGE':
          start = moment(startDate);
          end = moment(e).endOf('day');
          checkDiff(end, start, end, setEndDate);
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMKEZDETE':
          setStartDate(v === '' ? null : e)
          break;
        case 'FORMVEGE':
          setEndDate(v === '' ? null : e)
          break;
        default:
          break;
      }
    }
  }

  const checkDiff = (date, start, end, setDate) => {
    const diffDays = end.diff(start, 'days');
    if (diffDays > 365) {
      globals.addWarning("Az intervallum nem lehet egy évnél nagyobb.")
      return;
    } else {
      setDate(date);
    }
  }

  const loadList = () => {
    const listElement = lists.find(item => selectedLista == item.name) || {};
    let filters = {};
    filters.kezdete = startDate ? TimeFormatter.formatIso(startDate) : null;
    filters.vege = endDate ? TimeFormatter.formatIso(endDate) : null;
    filters.bontas = basis && basis.name;
    filters.kartyaTipusId = type && type.id;
    filters.tulajdonosId = owner && owner.id;
    filters.kartyaId = code && code.id;
    filters.helyszinId = location && location.id;
    filters.allapot = status && status.name;

    if (listElement) {
      listElement.submit(filters, (err, res) => {
        if (!err) {
          setTableData(res[0]);
        } else {
          setTableStatus('NETW');
        }
      });
    }
  }

  const loadXlsxList = () => {
    const listElement = lists.find(item => selectedLista == item.name) || {};
    let filters = {};
    filters.kezdete = startDate ? TimeFormatter.formatIso(startDate) : null;
    filters.vege = endDate ? TimeFormatter.formatIso(endDate) : null;
    filters.bontas = basis && basis.name;
    filters.kartyaTipusId = type && type.id;
    filters.tulajdonosId = owner && owner.id;
    filters.kartyaId = code && code.id;
    filters.helyszinId = location && location.id;
    filters.allapot = status && status.name;

    if (listElement) {
      listElement.submitXlsx(filters, (err, res) => {
        if (!err) {
          globals.addSuccess('Xlsx fájl letöltés indítása...');
          FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), listElement.listTitle);
        }
        toggleLoadingButton(false);
      });
    }
  }

  const loadHelyszinOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !location && options.length === 1) {
          setLocation(options[0]);
        }
      }
    });
  }

  const loadKartyaTipusOptions = (input, callback) => {
    Services.listKartyaTipusSelect(false, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !type && options.length === 1) {
          setType(options[0]);
        }
      }
    });
  }

  const loadVasarloiKartyaOptions = (input, callback) => {
    let filters = {};
    filters['kartyaTipusId'] = type && type.id;
    filters['aktiv'] = 'OSSZES';
    Services.listVasarloiKartya(filters, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.azonosito.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadPartnerOptions = (input, callback) => {
    const partnerCsoportId = type && type.partnerCsoportId;
    Services.listPartner(partnerCsoportId, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadSzemelyOptions = (input, callback) => {
    Services.listDolgozo(null, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadBontasOptions = (input, callback) => {
    Services.listBontas((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.caption.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadAllapotOptions = (input, callback) => {
    Services.listAllapot((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.label && k.label.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const visibleFilter = (filter, listElement) => {
    return listElement && listElement.filters && listElement.filters.includes(filter);
  }

  const renderListaFilters = () => {
    const listElement = lists.find(item => selectedLista == item.name) || {};
    return (
      <div className="row" style={{ marginTop: '20px', marginBottom: '20px' }}>
        <RFForm onSubmit={ () => {} }>
        {visibleFilter("startDate", listElement) &&
          <div className="col-md-2">
            <DatetimePicker
              label={'Kezdete:'}
              id="startDate"
              name="startDate"
              value={startDate && new Date(startDate)}
              // onChange={(e, v) => handleStartDateChange(v)}
              onChange={(e,v) => {handleDateChange(e,v,'FORMKEZDETE')}}
              onSelect={(e,v) => { selected = true }}
              containerClassName="organw-date-time"
              time
              // format="YYYY-MM-DD HH:mm:ss"
              messages={{ dateButton: "dátum", timeButton: "idő" }}
              timePrecision="seconds"
            />
          </div>
        }
        {visibleFilter("endDate", listElement) &&
          <div className="col-md-2"> 
            <DatetimePicker
              label={'Vége:'}
              id="endDate"
              name="endDate"
              value={endDate && new Date(endDate)}
              // onChange={(e, v) => handleEndDateChange(v)}
              onChange={(e,v) => {handleDateChange(e,v,'FORMVEGE')}}
              onSelect={(e,v) => { selected = true }}
              containerClassName="organw-date-time"
              time
              // format="YYYY-MM-DD HH:mm:ss"
              messages={{ dateButton: "dátum", timeButton: "idő" }}
              timePrecision="seconds"
            />
          </div>
        }
        {visibleFilter("basis", listElement) &&
          <div className="col-md-2">
            <SelectField
              variant='async'
              label='Bontás:'
              name="basis"
              id="basis"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setBasis(v)}
              loadOptions={_.debounce(loadBontasOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={basis}
              defaultOptions
              isClearable
            />
          </div>
        }
        {visibleFilter("location", listElement) &&
          <div className="col-md-2">
            <SelectField
              variant='async'
              label='Helyszín:'
              name="location"
              id="location"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setLocation(v)}
              loadOptions={_.debounce(loadHelyszinOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={location}
              defaultOptions
              isClearable
            />
          </div>
        }
        {visibleFilter("type", listElement) &&
          <div className="col-md-2">
            <SelectField
              variant='async'
              label='Kártyatípus:'
              name="type"
              id="type"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => {
                setType(v);
                setOwner(null);
              }}
              loadOptions={_.debounce(loadKartyaTipusOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={type}
              defaultOptions
              isClearable
            />
          </div>
        }
        {visibleFilter("owner", listElement) && type &&
          <div className="col-md-2">
            {type.csoport.name.includes('PARTNER') && (
              <SelectField
                variant='async'
                label='Tulajdonos:'
                name="owner"
                id="owner"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => setOwner(v)}
                loadOptions={_.debounce(loadPartnerOptions, 1000)}
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.id}
                value={owner}
                isClearable
              />
            )}
            {type.csoport.name.includes('SZEMELY') && (
              <SelectField
                variant='async'
                name="owner"
                label='Tulajdonos:'
                id="owner"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => setOwner(v)}
                loadOptions={_.debounce(loadSzemelyOptions, 1000)}
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.id}
                value={owner}
                isClearable
              />
            )}
          </div>
        }
        {visibleFilter("status", listElement) &&
          <div className="col-md-2">
            <SelectField
              variant='async'
              label='Állapot:'
              name="status"
              id="status"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setStatus(v)}
              loadOptions={_.debounce(loadAllapotOptions, 1000)}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.name}
              value={status}
              defaultOptions
              isClearable
            />
          </div>
        }
        {visibleFilter("code", listElement) &&
          <div className="col-md-2">
            <SelectField
              variant='async'
              label='Azonosító:'
              name="code"
              id="code"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setCode(v)}
              loadOptions={_.debounce(loadVasarloiKartyaOptions, 1000)}
              getOptionLabel={option => option.azonosito}
              getOptionValue={option => option.id}
              value={code}
              isClearable
            />
          </div>
        }
        </RFForm>
      </div>
    );
  }

  const renderListaTable = () => {
    const listElement = lists.find(item => selectedLista == item.name) || {};

    const options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: renderListaSummary,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    let columns = [];
    if (listElement && listElement.table) {
      listElement.table.forEach(column => {
        if (!column.dep || column.dep.every(f => !!f)) {

          const style = {
            ...{
              wordBreak: 'break-word',
              whiteSpace: 'pre-line',
            }, ...column.style || {}
          };

          let columnOptions = {
            dataField: column.name,
            text: column.label,
            filter: textFilter({
              delay: 400, // default is 500ms
              placeholder: 'Keresés...',
            }),
            style: style,
            sort: true,
          };
          if (column.formatter) {
            columnOptions = Object.assign(columnOptions, { formatter: column.formatter });
          }
          columns.push(columnOptions);
        }
      });
    }

    columns.push({
      dataField: 'id',
      text: '',
      hidden: true,
    });

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={tableData}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  const numberFormat = num => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  const renderListaSummary = (start, to, total) => {
    const count = tableData.map(data => data.mennyiseg).reduce((acc, curr) => acc + curr, 0);
    const sum = tableData.map(data => data.osszeg).reduce((acc, curr) => acc + curr, 0);

    return (tableData && tableData.length > 0 && (
      <span>
        {' '}
        <Button className="text-black" >
          {start} - {to} / {total} tétel megjelenítése
      </Button>
        <span className="pull-right" >
          <span className="h5">Összesen:    </span>
          {' '}
          <span>{numberFormat(count) + " db"}</span>
          {' '}
          <span>{numberFormat(sum) + " HUF"}</span>
        </span>
      </span>
    ));
  }

  const setArrowDirection = () => {
    const listIdx = lists.findIndex(item => selectedLista == item.name) || 0;
    let rowIdx = 0;
    for (let index = 0; index < lists.length; index += cols) {
      if (listIdx >= index && listIdx < index + cols) {
        rowIdx = index == 0 ? 0 : Math.floor(lists.length / (index + cols));
      }
    }
    let position = listIdx - (rowIdx * cols);
    if (cols % 2 == 0) {
      if (position >= cols / 2) return "RIGHT";
      else return "LEFT";
    } else {
      const centerIdx = Math.floor(cols / 2);
      if (centerIdx == position) return "MIDDLE";
      else if (centerIdx >= position) return "LEFT";
      else if (centerIdx <= position) return "RIGHT";
    }
  }

  const renderListaContent = () => {
    const listElement = lists.find(item => selectedLista == item.name) || {};
    const direction = setArrowDirection();

    return (
      <React.Fragment>
        <div className="row" style={{ margin: '20px' }}>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <Button type="button" color="secondary" style={{ width: '100%' }} onClick={() => setSelectedLista(null)}>
              {direction === "LEFT" && (
                <React.Fragment>
                  <i className="fa fa-backward" aria-hidden="true"></i>
                  <span>{'  '}</span>
                </React.Fragment>
              )}
              {listElement.label}
              {direction === "RIGHT" &&
                <React.Fragment>
                  <span>{'  '}</span>
                  <i className="fa fa-forward" aria-hidden="true"></i>
                </React.Fragment>
              }
            </Button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <h5>Szűrési feltételek: </h5>
          </div>
          <div className="col-md-2">
            <Button type="button" color="primary" onClick={() => setTableStatus('LOAD')}>
              <i className="fa fa-search" aria-hidden="true"></i>
            </Button>
            <span>{"  "}</span>
            <Button type="button" color="success" onClick={() => toggleLoadingButton(true)}>
              <i className="fa fa-download" aria-hidden="true"></i>
            </Button>
          </div>
        </div>
        {renderListaFilters()}
        {renderListaTable()}
      </React.Fragment>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {!selectedLista && <ListaSelector cols={cols} list={lists} selectLista={setSelectedLista} globals={globals} />}
        {selectedLista && renderListaContent()}
      </div>
    </div>
  );
}


export default ListaContent;